import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import "./Hero.css";
import SEO from "../SEO";

export default function Hero() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 900,
      mirror: false,
    });
  }, []);

  const projects = [
    {
      id: 1,
      name: "Clothing E-Commerce Store",
      category: "Website",
      icon: "🛍️",
      description: "Modern fashion store with cart & checkout system.",
      image: "/img/Anabiyahscollection.png",
      url: "https://anabiyhscollections.com/",
    },
    {
      id: 2,
      name: "Solar Energy Website",
      category: "Website",
      icon: "☀️",
      description: "Lead generation website for solar business.",
      image: "/img/SolidERA-Energy.png",
      url: "http://solidera-energy.com/",
    },
    {
      id: 3,
      name: "Pharmacy Distributor Website",
      category: "Website",
      icon: "💊",
      description: "Corporate pharma website with product listing.",
      image: "/img/ags.png",
      url: "https://web.agssukkur.com/",
    },
    {
      id: 4,
      name: "POS System",
      category: "Software",
      icon: "🛒",
      description: "Billing + inventory management system.",
      video: "https://www.youtube.com/embed/MWEID7Io39s",
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 5,
      name: "Advanced POS",
      category: "Software",
      icon: "💳",
      description: "Touch POS with advanced controls.",
      video: "https://www.youtube.com/embed/gTiGXKNYYEE",
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 6,
      name: "ERP System",
      category: "Software",
      icon: "📦",
      description: "Complete ERP for business automation.",
      video: "https://www.youtube.com/embed/6unp9xeoQMQ",
      url: "/Portfolio/EnterpriseERP/index",
    },
  ];

  const features = [
    {
      icon: "📊",
      title: "ERP Software",
      desc: "Complete business management system with inventory, accounts and reporting.",
    },
    {
      icon: "💳",
      title: "POS System",
      desc: "Fast billing, barcode scanning and sales tracking for retail businesses.",
    },
    {
      icon: "🧾",
      title: "FBR Integration",
      desc: "Digital invoicing and FBR compliant POS integration solutions.",
    },
    {
      icon: "🌐",
      title: "Website Development",
      desc: "SEO optimized business websites designed for speed and conversions.",
    },
    {
      icon: "🛍️",
      title: "E-Commerce Solutions",
      desc: "Online stores with payment integration and checkout systems.",
    },
    {
      icon: "📱",
      title: "Mobile Applications",
      desc: "Modern Android & iOS applications for growing businesses.",
    },
  ];

  const benefits = [
    {
      icon: "⚡",
      title: "Fast Delivery",
      desc: "Quick turnaround without compromising quality.",
    },
    {
      icon: "💰",
      title: "Affordable Pricing",
      desc: "Budget friendly solutions for startups and enterprises.",
    },
    {
      icon: "🛠️",
      title: "Custom Solutions",
      desc: "Software tailored according to your business workflow.",
    },
    {
      icon: "📈",
      title: "Scalable Systems",
      desc: "Built using modern technologies for future growth.",
    },
    {
      icon: "🔒",
      title: "Secure Architecture",
      desc: "Reliable and secure systems with data protection.",
    },
    {
      icon: "🕒",
      title: "24/7 Support",
      desc: "Ongoing support and maintenance whenever you need help.",
    },
  ];

  const industries = [
    "🛒 Supermarket POS Software",
    "💊 Pharmacy Management System",
    "🍔 Restaurant POS Software",
    "👕 Garments Store POS",
    "🏫 School Management System",
    "🚚 Distribution ERP Software",
    "🏥 Hospital Management System",
    "📱 Mobile Shop Billing Software",
  ];

  const faqs = [
    {
      q: "Which is the best ERP software in Pakistan?",
      a: "MZR Software provides scalable ERP solutions with inventory, accounting, reporting and automation features for businesses across Pakistan.",
    },
    {
      q: "Do you provide FBR invoice integration?",
      a: "Yes, we provide FBR integrated invoicing solutions for POS systems, ERP software and retail businesses.",
    },
    {
      q: "What features does your POS system include?",
      a: "Our POS system includes billing, inventory tracking, barcode support, reporting and user management.",
    },
    {
      q: "Do you build custom software solutions?",
      a: "Yes, we develop fully customized software according to your business requirements and workflow.",
    },
  ];

  return (
    <>
      <SEO
        title="Custom ERP, POS & Web Development Company in Pakistan | MZR Software"
        description="MZR Software provides ERP systems, POS software, FBR invoice integration, websites, e-commerce and custom software development services in Pakistan."
        url="https://mzrsoftware.com/"
      />

      <div className="page-shell">
        {/* HEADER */}
        <header className="site-header sticky-header" data-aos="fade-down">
          <div className="container header-inner">
            <nav className="nav-links">
              <a href="#features">Features</a>
              <a href="#benefits">Benefits</a>
              <a href="#screenshots">Screenshots</a>
              <a href="#industries">Industries</a>
              <a href="#faqs">FAQs</a>
            </nav>

            <Link to="/Contact/index" className="btn header-cta">
              Get Quote
            </Link>
          </div>
        </header>

        <main>
          {/* HERO / H1 */}
          <section className="hero-section">
            <div className="hero-overlay"></div>

            <div className="container hero-grid">
              <div className="hero-copy" data-aos="fade-right">
                <div className="hero-badges">
                  <span>🔥 100+ Projects</span>
                  <span>⚡ Fast Delivery</span>
                  <span>💰 Affordable Pricing</span>
                </div>

                <h1>
                  Custom ERP, POS & Software Development Company in Pakistan
                </h1>

                <p className="hero-subheading">
                  We build ERP systems, POS software, websites, e-commerce
                  stores and custom business applications to automate and grow
                  your business.
                </p>

                <div className="hero-actions">
                  <a
                    href="https://wa.me/923351206586?text=Hi%20I%20need%20software%20development%20services"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary glow-btn"
                  >
                    🚀 Get Free Consultation
                  </a>

                  <a href="#screenshots" className="btn btn-secondary">
                    View Projects →
                  </a>
                </div>

                <div className="hero-trust">
                  ✔ ERP Solutions • ✔ POS Systems • ✔ Web Development
                </div>
              </div>

              <div className="hero-panel" data-aos="fade-left">
                <div className="hero-card">
                  <div className="panel-icon">📊</div>
                  <h3>ERP Software</h3>
                  <p>Inventory, accounts and reporting automation.</p>
                </div>

                <div className="hero-card">
                  <div className="panel-icon">💳</div>
                  <h3>POS System</h3>
                  <p>Fast billing and stock management solutions.</p>
                </div>

                <div className="hero-card">
                  <div className="panel-icon">🌐</div>
                  <h3>Business Websites</h3>
                  <p>Modern websites optimized for SEO and speed.</p>
                </div>

                <div className="hero-card">
                  <div className="panel-icon">🧾</div>
                  <h3>FBR Integration</h3>
                  <p>Digital invoicing and compliance solutions.</p>
                </div>
              </div>
            </div>
          </section>

          {/* INTRODUCTION */}
          <section className="section intro-section">
            <div className="container" data-aos="fade-up">
              <div className="section-head text-center">
                <p className="eyebrow">Introduction</p>

                <h2>Leading Software House in Pakistan</h2>

                <p className="section-copy">
                  MZR Software provides ERP systems, POS software, FBR invoice
                  integration, websites, e-commerce stores and custom software
                  solutions for startups and enterprises across Pakistan.
                </p>

                <p className="section-copy">
                  We help businesses automate billing, inventory, accounting,
                  reporting and customer management using scalable modern
                  technologies.
                </p>
              </div>
            </div>
          </section>

          {/* FEATURES */}
          <section className="section services-section" id="features">
            <div className="container">
              <div className="section-head text-center">
                <p className="eyebrow">Features</p>

                <h2>Business Software & Web Development Services</h2>
              </div>

              <div className="services-grid">
                {features.map((item, index) => (
                  <div className="service-card" key={index} data-aos="fade-up">
                    <div className="service-icon">{item.icon}</div>

                    <h3>{item.title}</h3>

                    <p>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* BENEFITS */}
          <section className="section benefits-section" id="benefits">
            <div className="container">
              <div className="section-head text-center">
                <p className="eyebrow">Benefits</p>

                <h2>Why Businesses Choose MZR Software</h2>
              </div>

              <div className="why-grid">
                {benefits.map((item, index) => (
                  <div className="why-card" key={index} data-aos="fade-up">
                    <div className="why-icon">{item.icon}</div>

                    <h3>{item.title}</h3>

                    <p>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* SCREENSHOTS */}
          <section className="section portfolio-section" id="screenshots">
            <div className="container">
              <div className="section-head">
                <p className="eyebrow">Screenshots</p>

                <h2>Recent Projects & Software Screenshots</h2>
              </div>

              <div className="portfolio-grid">
                {projects.map((project) => {
                  const isExternal = project.url.startsWith("http");

                  const Card = (
                    <div className="portfolio-card">
                      <div className="card-image-wrapper">
                        {project.video ? (
                          <iframe
                            src={project.video}
                            className="project-video"
                            title={project.name}
                          ></iframe>
                        ) : (
                          <img
                            src={project.image}
                            alt={project.name}
                            className="project-image"
                          />
                        )}

                        <div className="card-overlay">
                          <span className="project-icon">{project.icon}</span>

                          <span className="visit-icon">View Project</span>
                        </div>
                      </div>

                      <div className="card-content">
                        <h3>{project.name}</h3>

                        <span className="category-badge">
                          {project.category}
                        </span>

                        <p>{project.description}</p>
                      </div>
                    </div>
                  );

                  return isExternal ? (
                    <a
                      key={project.id}
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {Card}
                    </a>
                  ) : (
                    <Link key={project.id} to={project.url}>
                      {Card}
                    </Link>
                  );
                })}
              </div>
            </div>
          </section>

          {/* INDUSTRIES */}
          <section className="section industries-section" id="industries">
            <div className="container">
              <div className="section-head text-center">
                <p className="eyebrow">Industries</p>

                <h2>Industries Using Our ERP & POS Software</h2>

                <p className="section-copy">
                  We provide software solutions for retail shops, pharmacies,
                  restaurants, schools, wholesalers and enterprises.
                </p>
              </div>

              <div className="industries-grid">
                {industries.map((industry, index) => (
                  <div className="industry-card" key={index}>
                    {industry}
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQS */}
          <section className="section faq-section" id="faqs">
            <div className="container">
              <div className="section-head text-center">
                <p className="eyebrow">FAQs</p>

                <h2>Frequently Asked Questions</h2>
              </div>

              <div className="accordion" id="faqAccordion">
                {faqs.map((faq, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`faq${index}`}>
                      <button
                        className={`accordion-button ${
                          index !== 0 ? "collapsed" : ""
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index}`}
                      >
                        {faq.q}
                      </button>
                    </h2>

                    <div
                      id={`collapse${index}`}
                      className={`accordion-collapse collapse ${
                        index === 0 ? "show" : ""
                      }`}
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">{faq.a}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="section cta-section">
            <div className="container final-cta-card">
              <div>
                <p className="eyebrow">Ready to grow your business?</p>

                <h2>
                  Launch Your ERP, POS or Software Project with MZR Software
                </h2>

                <p>
                  Get custom software solutions designed specifically for your
                  business needs.
                </p>
              </div>

              <a
                href="https://wa.me/923351206586?text=Hi%20I%20need%20a%20software%20solution"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-large"
              >
                📲 Start Your Project
              </a>
            </div>
          </section>
        </main>
      </div>
    </>
  );
}
